<template>
  <audio
    v-if="canPlayLeaderboardMusic"
    :src="leaderboardMusic"
    :autoplay="true"
    preload="auto"
    ref="leaderboard-music"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import utils from '@/util'
import constants from '@/constant'
import EventBus from '@/eventBus'

const finalLeaderboardMusic = require('@/assets/audio/final-leaderboard-music.mp3')
const middleLeaderboardMusic = require('@/assets/audio/middle-leaderboard-music.mp3')

export default {
  data() {
    return {
      leaderboardLoaded: null,
    }
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
    }),
    canPlayLeaderboardMusic() {
      return this.presentation.isEnableQuizMusic &&
        !this.sharePresentation &&
        !this.slideActive.audioLink &&
        this.slideActive.type === 'leaderboard' &&
        this.isPresenting &&
        !this.isBackstage &&
        this.leaderboardLoaded
    },
    isFinalLeaderboard() {
      let isFinalLeaderboard = false
      const { slides } = this.presentation

      const slidesQuiz = slides.filter((item) => {
        return item.type === 'pickAnswer'
      })

      const index = utils.getIndexSlide(slides, this.slideActive.id)
      let indexQuiz = 0
      if (slidesQuiz.length) {
        indexQuiz = utils.getIndexSlide(
          slides,
          slidesQuiz[slidesQuiz.length - 1].id,
        )
      }
      if (index > indexQuiz) {
        isFinalLeaderboard = true
      }
      return isFinalLeaderboard
    },
    leaderboardMusic() {
      return this.isFinalLeaderboard ? finalLeaderboardMusic : middleLeaderboardMusic
    },
  },
  mounted() {
    EventBus.$on('leaderboard-loaded', (isLoaded) => {
      this.leaderboardLoaded = isLoaded
    })
    EventBus.$on('play-quiz-music', (isEnableQuizMusic) => {
      if (!this.$refs['leaderboard-music']) return
      if (isEnableQuizMusic) {
        this.$refs['leaderboard-music'].play().catch(() => {})
        utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          `Presenting mode > Enable ${this.isFinalLeaderboard ? 'final' : 'middle'} leaderboard quiz music`,
        )
      } else {
        this.$refs['leaderboard-music'].pause()
        utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          `Presenting mode > Disable ${this.isFinalLeaderboard ? 'final' : 'middle'} leaderboard quiz music`,
        )
      }
    })
  },
  destroyed() {
    EventBus.$off('leaderboard-loaded')
    EventBus.$off('play-quiz-music')
  },
}
</script>
